import {Image} from '@aboutyou/ui-components';
import React, {FC, ImgHTMLAttributes} from 'react';

const FLAG_HEIGHT = 16;
const FLAG_WIDTH = 19;

export const CountryFlag: FC<
  {className?: string; alt: string} & ImgHTMLAttributes<HTMLImageElement>
> = ({src, height, width, ...props}) => {
  if (!src) return null;

  return (
    <Image
      breakpoints={[{columns: 40}]}
      ratio="5:4"
      importance="low"
      loading="lazy"
      src={src}
      widths={[width ? Number(width) : FLAG_WIDTH]}
      height={height ? Number(height) : FLAG_HEIGHT}
      width={width ? Number(width) : FLAG_WIDTH}
      {...props}
    />
  );
};
